import { LookupTypes } from "../enums/lookupTypes";
import environment from "../environment";
import { GET, GETWithParams } from "./http.service";

// const endpoint = environment.TOTAL_ENDPOINT;
const endpoint = environment.LOOKUP_ENDPOINT;

export const getFeatures = async () => {
  const response = await GETWithParams(
    `${endpoint}`,
    { lookupType: LookupTypes?.Features },
    false
  );
  return response;
};

export const getStatistics = async () => {
  const response = await GET(`Home/stats-public`, false);
  return response;
};

export const getRegisteredStatistics = async () => {
  const response = await GET(
    `Home/stats-registered`,
    localStorage.getItem(environment.TOKEN_KEY)
  );
  return response;
};

export const getAllAdministrativeStaff = async () => {
  const response = await GETWithParams(
    `${endpoint}`,
    { lookupType: LookupTypes?.AdministrativeStaff },
    false
  );
  return response;
};

export const getAllPartners = async () => {
  const response = await GET(`Partner`, false);
  return response;
};
